import React from "react";
import "./AgentRegister.scss";

/**
 * Shell for agent registration / billing surfaces.
 * - full (default for register flow): single column, form uses entire viewport width.
 * - split: optional aside (e.g. benefits) + main — only when `aside` is provided.
 * - success: main only.
 */
export default function AgentRegisterShell({ variant = "full", aside = null, children }) {
  const isSuccess = variant === "success";
  const showAside = !isSuccess && aside != null;
  const layoutClass = isSuccess
    ? "agent-register--success"
    : showAside
      ? "agent-register--split"
      : "agent-register--full";

  return (
    <div className={`agent-register ${layoutClass}`}>
      {showAside ? (
        <aside className="agent-register__aside" aria-label="יתרונות ההצטרפות">
          {aside}
        </aside>
      ) : null}
      <div className="agent-register__main">{children}</div>
    </div>
  );
}
